"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.inputStyles = exports.focusStyles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../../Constant");

var _theme;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  border-bottom: 1px solid ", ";\n\n  &:focus {\n    ", "\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n    outline-offset: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var focusStyles = (0, _styledTheming.default)('mode', (_theme = {
  caliber: "border-color: ".concat(_Constant.Color.CALIBER_BLUE_NEW, ";")
}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "border-color: ".concat(_Constant.Color.HOMEBRIDGE_BLUE, ";")), (0, _defineProperty2.default)(_theme, "homepoint", "border-color: ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, "border-color: ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK, ";")), (0, _defineProperty2.default)(_theme, "figure", "border-color: ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme, "pella", "border-color: ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme, "petersendean", "border-color: ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "border-color: ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";")), _theme));
exports.focusStyles = focusStyles;
var inputStyles = "\n  font-family: ".concat(_Constant.Font.PRIMARY_FONT, ";\n  font-weight: 600;\n  background-color: initial;\n  border: 0;\n  width: 100%;\n  font-size: 1.5rem;\n  color: ").concat(_Constant.Color.BLACK_SOUL, ";\n  margin-top: 4px;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 4px;\n  line-height: normal;\n  appearance: none;\n  outline: none;\n\n  &::placeholder {\n    color: ").concat(_Constant.Color.GREY_4, ";\n  }\n  &:-ms-input-placeholder {\n    color: ").concat(_Constant.Color.GREY_4, ";\n  }\n  &::-ms-input-placeholder {\n    color: ").concat(_Constant.Color.GREY_4, ";\n  }\n\n  &:disabled {\n    padding: 5px;\n    cursor: not-allowed;\n    color: ").concat(_Constant.Color.MEDIUM_GREY, " !important;\n    opacity: 1;\n  }\n\n  &:invalid,\n  &:-moz-submit-invalid,\n  &:-moz-ui-invalid {\n    box-shadow: none;\n  }\n");
exports.inputStyles = inputStyles;

var _default = _styledComponents.default.input.attrs(function (_ref) {
  var errorText = _ref.errorText,
      className = _ref.className,
      fsMask = _ref.fsMask;
  return {
    'data-error': errorText && errorText.length > 0,
    className: "".concat(fsMask ? 'fs-mask ' : '').concat(className || '')
  };
})(_templateObject(), inputStyles, function (props) {
  return props['data-error'] ? _Constant.Color.ERROR : _Constant.Color.GREY_4;
}, focusStyles);

exports.default = _default;